define('OutSystems/ClientRuntime/Communication',["require", "exports", "tslib", "./ApplicationInfo", "./ClientInfo", "./CookiesManager", "./Exceptions", "./Flow", "./Injector", "./Injector/KnownServices", "./Logger", "./Request"], function (require, exports, tslib_1, ApplicationInfo, ClientInfo_1, CookiesManager, Exceptions, Flow, Injector, KnownServices_1, Logger, Request) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getRoles = exports.initialize = exports.postLog = exports.post = exports.get = exports.NetworkStatus = exports.LocaleInfo = exports.CSRF = exports.ROLES_REQUEST_ENDPOINT = exports.COMMUNICATION_MODULE_NAME = void 0;
    exports.COMMUNICATION_MODULE_NAME = "Communication";
    var LOG_POST_TIMEOUT = 10000;
    var CUSTOM_HEADER_PREFIX = "OutSystems-";
    var CUSTOM_HEADER_PREFIX_RX_CI = new RegExp("^" + CUSTOM_HEADER_PREFIX, "i");
    exports.ROLES_REQUEST_ENDPOINT = "moduleservices/roles";
    var ROLES_REQUEST_TIMEOUT = 10000;
    var timeoutsDisabledWhenDebugging = false;
    var userCookieName;
    var onNewVersion;
    var CSRF;
    (function (CSRF) {
        CSRF.CSRFHeader = "X-CSRFToken";
        CSRF.AnonymousCSRFToken = "T6C+9iB49TLra4jEsMeSckDMNhQ=";
        function getCSRFToken() {
            var cookieValue = CookiesManager.readCookie(userCookieName);
            if (cookieValue === null) {
                Logger.trace(exports.COMMUNICATION_MODULE_NAME, "User cookie " + userCookieName + " not found. Request CSRF header set to " + CSRF.AnonymousCSRFToken);
                return CSRF.AnonymousCSRFToken;
            }
            var csfTokenRegex = /crf=([^;]+)/;
            var match = cookieValue.match(csfTokenRegex);
            if (match === null) {
                Logger.trace(exports.COMMUNICATION_MODULE_NAME, "User cookie " + userCookieName + " found with value: " + cookieValue + ". But no 'crf' key found");
                throw new Error("Cookie format error: no 'crf' key found");
            }
            return match[1];
        }
        CSRF.getCSRFToken = getCSRFToken;
    })(CSRF || (exports.CSRF = CSRF = {}));
    var LocaleInfo;
    (function (LocaleInfo) {
        LocaleInfo.LocaleHeader = CUSTOM_HEADER_PREFIX + "locale";
        function getLocaleValue() {
            var localeService = Injector.resolve(KnownServices_1.ServiceNames.LocaleService);
            if (localeService) {
                return localeService.getCurrentLocale();
            }
        }
        LocaleInfo.getLocaleValue = getLocaleValue;
        function setLocaleValue(locale) {
            var localeService = Injector.resolve(KnownServices_1.ServiceNames.LocaleService);
            if (localeService) {
                localeService.setCurrentLocale(locale);
            }
        }
        LocaleInfo.setLocaleValue = setLocaleValue;
    })(LocaleInfo || (exports.LocaleInfo = LocaleInfo = {}));
    var NetworkStatusModule;
    (function (NetworkStatusModule) {
        function isOnline() {
            var globalObj = typeof window !== "undefined" ? window : global;
            var isNetworkPluginAvailable = globalObj && globalObj.cordova && globalObj.navigator && globalObj.navigator.connection;
            if (isNetworkPluginAvailable) {
                return globalObj.navigator.connection.type !== "none";
            }
            else {
                return globalObj.navigator.onLine;
            }
        }
        NetworkStatusModule.isOnline = isOnline;
        function onOnline(callback) {
            if (typeof document !== "undefined" && document.addEventListener) {
                document.addEventListener("online", callback, false);
            }
        }
        NetworkStatusModule.onOnline = onOnline;
        function onOffline(callback) {
            if (typeof document !== "undefined" && document.addEventListener) {
                document.addEventListener("offline", callback, false);
            }
        }
        NetworkStatusModule.onOffline = onOffline;
        function ping(timeout, getBasePath) {
            if (getBasePath === void 0) { getBasePath = ApplicationInfo.getBasePath; }
            var url = "moduleservices/ping";
            return get(url, timeout, true, false, false, getBasePath());
        }
        NetworkStatusModule.ping = ping;
    })(NetworkStatusModule || (NetworkStatusModule = {}));
    exports.NetworkStatus = NetworkStatusModule;
    function getRandomInt() {
        var min = 0;
        var max = 9007199254740991;
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    function onNewModuleVersion(currentViewHasChanged, isAutoUpgradeDisabled) {
        if (onNewVersion) {
            onNewVersion(currentViewHasChanged, isAutoUpgradeDisabled);
        }
    }
    function createHttpRequest(_a) {
        return tslib_1.__awaiter(this, arguments, void 0, function (_b) {
            var request, locale;
            var _c = _b.method, method = _c === void 0 ? "POST" : _c, url = _b.url, basePath = _b.basePath, _d = _b.useLocaleInfo, useLocaleInfo = _d === void 0 ? false : _d;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4, Request.createHttpRequest({ method: method, url: url, basePath: basePath })];
                    case 1:
                        request = _e.sent();
                        if (useLocaleInfo) {
                            locale = LocaleInfo.getLocaleValue();
                            if (locale) {
                                request.setHeader(LocaleInfo.LocaleHeader, locale);
                            }
                        }
                        request.setHeader(CSRF.CSRFHeader, CSRF.getCSRFToken());
                        request.setHeader("Content-Type", "application/json; charset=UTF-8");
                        request.setHeader("Accept", "application/json");
                        return [2, request];
                }
            });
        });
    }
    function checkRequestSuspendedByDebugger(requestToken, basePath) {
        return Flow.promise(function (resolve, reject) {
            var url = "/moduleservices/checkrequestsuspended?requestToken=".concat(requestToken);
            createHttpRequest({ method: "GET", url: url, basePath: basePath })
                .then(function (request) {
                var handleError = function () { return resolve(false); };
                request.onSuccess = function (response) {
                    if (response.statusCode === 200) {
                        resolve(JSON.parse(response.responseText));
                    }
                    else {
                        handleError();
                    }
                };
                request.onTimeout = handleError;
                request.onError = handleError;
                request.onAbort = handleError;
                request.setTimeout(10 * 1000);
                request.send();
            })
                .catch(reject);
        });
    }
    function sendWithTimeout(request, data, basePath, timeout, disableTimeoutWhenDebugging) {
        if (timeout) {
            if (disableTimeoutWhenDebugging) {
                var requestToken_1 = getRandomInt().toString();
                var timeoutHandle_1 = setTimeout(function () {
                    if (!request.isDone()) {
                        checkRequestSuspendedByDebugger(requestToken_1, basePath).then(function (isSuspended) {
                            if (!isSuspended) {
                                request.abort();
                                request.onTimeout(null);
                            }
                        });
                    }
                }, timeout * 1000);
                request.onFinish = function () {
                    clearTimeout(timeoutHandle_1);
                };
                request.setHeader(CUSTOM_HEADER_PREFIX + "Request-Token", requestToken_1);
            }
            else {
                request.setTimeout(timeout * 1000);
            }
        }
        request.setBody(data);
        request.send();
    }
    function getCommunicationErrorMessage(url, status, aborted) {
        if (aborted === void 0) { aborted = false; }
        var reason = aborted ? " (request aborted)" : "";
        return "Unable to access '".concat(url, "'").concat(reason, ". Error Code: ").concat(status);
    }
    function get(url, timeout, checkOffline, parseResponse, useInvalidationSuffix, basePath) {
        if (timeout === void 0) { timeout = undefined; }
        if (checkOffline === void 0) { checkOffline = false; }
        if (parseResponse === void 0) { parseResponse = true; }
        if (useInvalidationSuffix === void 0) { useInvalidationSuffix = true; }
        return new Promise(function (resolve, reject) {
            if (checkOffline && typeof navigator !== "undefined" && !navigator.onLine) {
                return reject("Unable to access '".concat(url, "' - There's no network connection."));
            }
            var cacheInvalidationSuffix = useInvalidationSuffix ? "" : "?" + new Date().getTime();
            var urlWithCacheSuffix = "".concat(url).concat(cacheInvalidationSuffix);
            Request.createHttpRequest({ method: "GET", url: urlWithCacheSuffix, basePath: basePath })
                .then(function (request) {
                request.onSuccess = function (response) {
                    if (!response.complete || response.statusCode !== 200) {
                        return reject(getCommunicationErrorMessage(url, response.statusCode));
                    }
                    var parsedResponse;
                    if (parseResponse) {
                        try {
                            parsedResponse = JSON.parse(response.responseText.substring(response.responseText.indexOf("{"), response.responseText.length));
                        }
                        catch (e) {
                            return reject(e);
                        }
                        if (!parsedResponse) {
                            return reject(Error("Unable to parse payload downloaded from '".concat(url, "'.")));
                        }
                    }
                    resolve(parsedResponse);
                };
                request.onError = request.onTimeout = function (response) {
                    return reject(Error(getCommunicationErrorMessage(url, response.statusCode)));
                };
                request.onAbort = function (response) {
                    return reject(Error(getCommunicationErrorMessage(url, response.statusCode, true)));
                };
                if (timeout) {
                    request.setTimeout(timeout);
                }
                request.setHeader("Accept", "application/json");
                setDeviceInfoHeaders(request);
                request.send();
            })
                .catch(reject);
        });
    }
    exports.get = get;
    function post(url, payload, basePath, timeout, onTimeout, onResponseParsed, validateOutOfOrder, instanceId, headers, useLocaleInfo) {
        if (timeout === void 0) { timeout = undefined; }
        if (validateOutOfOrder === void 0) { validateOutOfOrder = false; }
        if (instanceId === void 0) { instanceId = 0; }
        if (useLocaleInfo === void 0) { useLocaleInfo = false; }
        return Flow.promise(function (resolve, reject) {
            var trackingUrl = url + instanceId;
            var reqId = validateOutOfOrder ? RequestSequenceTracker.startTracking(trackingUrl) : -1;
            var prevLocale = useLocaleInfo ? LocaleInfo.getLocaleValue() : undefined;
            createHttpRequest({ method: "POST", url: url, basePath: basePath, useLocaleInfo: useLocaleInfo })
                .then(function (request) {
                request.onSuccess = function (response) {
                    if (validateOutOfOrder) {
                        try {
                            var requestInfo = RequestSequenceTracker.getRequestInfo(reqId, trackingUrl);
                            if (requestInfo.isOutOfOrder) {
                                return reject(new Exceptions.Exceptions.OutOfOrderException("Response out of endpoint order: Endpoint= ".concat(url, " Last= ").concat(requestInfo.lastRequestId, " Got= ").concat(reqId)));
                            }
                        }
                        finally {
                            RequestSequenceTracker.stopTracking(trackingUrl);
                        }
                    }
                    var endpointOk = response.statusCode === 200;
                    var endpointOfflineOrLicenseProblem = response.statusCode === 503 && response.getHeader("Content-Type") === "application/json";
                    if (!endpointOk && !endpointOfflineOrLicenseProblem) {
                        if (response.statusCode === 404) {
                            onNewModuleVersion(true);
                            reject(new Exceptions.Exceptions.ViewHasChangedException());
                        }
                        else {
                            reject(new Exceptions.Exceptions.CommunicationException("Request failed with status " + response.statusCode));
                        }
                        return;
                    }
                    try {
                        if (useLocaleInfo) {
                            var locale = response.getHeader(LocaleInfo.LocaleHeader);
                            if (locale && prevLocale && locale !== prevLocale) {
                                LocaleInfo.setLocaleValue(locale);
                            }
                        }
                        var json = void 0;
                        try {
                            json = JSON.parse(response.responseText);
                        }
                        catch (ex) {
                            return reject(new Exceptions.Exceptions.CommunicationException("Invalid server response from ".concat(request.url, ": ").concat(ex.message), ex.stack));
                        }
                        if (!endpointOfflineOrLicenseProblem) {
                            if (!!json.versionInfo) {
                                if (json.versionInfo.hasModuleVersionChanged) {
                                    if (json.versionInfo.hasApiVersionChanged) {
                                        onNewModuleVersion(true, json.versionInfo.isAutoUpgradeDisabled);
                                        reject(new Exceptions.Exceptions.ViewHasChangedException());
                                        return;
                                    }
                                    else {
                                        onNewModuleVersion(false, json.versionInfo.isAutoUpgradeDisabled);
                                    }
                                }
                            }
                            if (!!onResponseParsed) {
                                var responseHeaders = getResponseCustomHeaders(response);
                                onResponseParsed(json, responseHeaders, { url: url });
                            }
                        }
                        if (!!json.exception) {
                            reject(Exceptions.getException(json.exception));
                        }
                        else {
                            resolve(json.data);
                        }
                    }
                    catch (e) {
                        reject(e);
                    }
                };
                request.onError = function () {
                    reject(new Exceptions.Exceptions.CommunicationException("Request failed with an error"));
                };
                if (timeout !== undefined) {
                    request.onTimeout = function () {
                        if (!!onTimeout) {
                            onTimeout();
                        }
                        reject(new Exceptions.Exceptions.CommunicationException("The connection has timed out"));
                    };
                }
                setRequestCustomHeaders(request, headers);
                setDeviceInfoHeaders(request);
                sendWithTimeout(request, JSON.stringify(payload), basePath, timeout, timeoutsDisabledWhenDebugging);
            })
                .catch(reject);
        });
    }
    exports.post = post;
    function postLog(logMessages, getBasePath) {
        if (getBasePath === void 0) { getBasePath = ApplicationInfo.getBasePath; }
        return Flow.promise(function (resolve, reject) {
            var url = "moduleservices/log";
            var cacheInvalidationSuffix = new Date().getTime();
            var urlWithCacheSuffix = "".concat(url, "?clientTimeInMillis=").concat(cacheInvalidationSuffix);
            createHttpRequest({ method: "POST", url: urlWithCacheSuffix, basePath: getBasePath() })
                .then(function (request) {
                request.onSuccess = function (response) {
                    if (response.statusCode === 200) {
                        resolve();
                    }
                    else {
                        reject(new Exceptions.Exceptions.CommunicationException("Logger: Error sending log to ".concat(url, ". Error Code: ").concat(response.statusCode)));
                    }
                };
                request.onError = function (response) {
                    reject(new Exceptions.Exceptions.CommunicationException("Logger: Error sending log to ".concat(url, ". Error Code: ").concat(response.statusCode)));
                };
                request.onAbort = function (response) {
                    reject(new Exceptions.Exceptions.CommunicationException("Logger: Error sending log to ".concat(url, " (Aborted). Error Code: ").concat(response.statusCode)));
                };
                request.onTimeout = function (_) {
                    reject(new Exceptions.Exceptions.CommunicationException("Logger: Error sending log to ".concat(url, " (Timeout).")));
                };
                request.setTimeout(LOG_POST_TIMEOUT);
                setDeviceInfoHeaders(request);
                request.setBody(JSON.stringify(logMessages));
                request.send();
            })
                .catch(reject);
        });
    }
    exports.postLog = postLog;
    function setDeviceInfoHeaders(request) {
        var clientInfo = (0, ClientInfo_1.getClientInfo)();
        if (clientInfo && clientInfo.device && clientInfo.device.uuid) {
            request.setHeader(CUSTOM_HEADER_PREFIX + "device-uuid", clientInfo.device.uuid);
        }
    }
    function setRequestCustomHeaders(request, headers) {
        if (request && headers) {
            for (var header in headers) {
                if (headers.hasOwnProperty(header)) {
                    request.setHeader(CUSTOM_HEADER_PREFIX + header, headers[header]);
                }
            }
        }
    }
    function getResponseCustomHeaders(response) {
        var headerMap = {};
        if (!response) {
            return headerMap;
        }
        var allHeaders = response.headers || {};
        return Object.keys(allHeaders)
            .filter(function (headerKey) { return !!headerKey.match(CUSTOM_HEADER_PREFIX_RX_CI); })
            .reduce(function (headerAggregator, headerKey) {
            var slicedKey = headerKey.substr(CUSTOM_HEADER_PREFIX.length);
            var value = allHeaders[headerKey];
            headerAggregator[slicedKey] = value;
            return headerAggregator;
        }, headerMap);
    }
    var RequestSequenceTracker;
    (function (RequestSequenceTracker) {
        var rid = 0;
        var perEndpointId = {};
        function startTracking(url) {
            rid++;
            var pendingRequestInfo = perEndpointId[url];
            if (!pendingRequestInfo) {
                perEndpointId[url] = {
                    requestId: rid,
                    counter: 1,
                };
            }
            else {
                pendingRequestInfo.requestId = rid;
                pendingRequestInfo.counter++;
            }
            return rid;
        }
        RequestSequenceTracker.startTracking = startTracking;
        function stopTracking(url) {
            var pendingRequestInfo = perEndpointId[url];
            if (!pendingRequestInfo) {
                throw new Error("There's no requestInfo for url : " + url);
            }
            pendingRequestInfo.counter--;
            if (pendingRequestInfo.counter <= 0) {
                delete perEndpointId[url];
            }
        }
        RequestSequenceTracker.stopTracking = stopTracking;
        function getRequestInfo(requestId, url) {
            var pendingRequestInfo = perEndpointId[url];
            if (!pendingRequestInfo) {
                throw new Error("There's no requestInfo for url : " + url);
            }
            var lastEndpointId = pendingRequestInfo.requestId;
            return {
                isOutOfOrder: lastEndpointId > requestId,
                lastRequestId: lastEndpointId,
            };
        }
        RequestSequenceTracker.getRequestInfo = getRequestInfo;
    })(RequestSequenceTracker || (RequestSequenceTracker = {}));
    function initialize(debugEnabled, cookieName, onNewVersionAfterAppReady) {
        timeoutsDisabledWhenDebugging = debugEnabled;
        if (cookieName) {
            userCookieName = cookieName;
        }
        if (onNewVersionAfterAppReady) {
            onNewVersion = onNewVersionAfterAppReady;
        }
    }
    exports.initialize = initialize;
    function getRoles() {
        return tslib_1.__awaiter(this, arguments, void 0, function (getBasePath) {
            var _this = this;
            if (getBasePath === void 0) { getBasePath = ApplicationInfo.getBasePath; }
            return tslib_1.__generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var url_1, cacheInvalidationSuffix, urlWithCacheSuffix, request, ex_1;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    url_1 = exports.ROLES_REQUEST_ENDPOINT;
                                    cacheInvalidationSuffix = new Date().getTime();
                                    urlWithCacheSuffix = "".concat(url_1, "?").concat(cacheInvalidationSuffix);
                                    return [4, createHttpRequest({
                                            method: "GET",
                                            url: urlWithCacheSuffix,
                                            basePath: getBasePath(),
                                        })];
                                case 1:
                                    request = _a.sent();
                                    request.onSuccess = function (response) {
                                        if (response.statusCode === 200) {
                                            try {
                                                resolve(JSON.parse(response.responseText).rolesInfo);
                                            }
                                            catch (ex) {
                                                reject(ex);
                                            }
                                        }
                                        else {
                                            reject(new Exceptions.Exceptions.CommunicationException(createGetRolesErrorMessage(url_1, { errorCode: response.statusCode })));
                                        }
                                    };
                                    request.onError = function (response) {
                                        reject(new Exceptions.Exceptions.CommunicationException(createGetRolesErrorMessage(url_1, { errorCode: response.statusCode })));
                                    };
                                    request.onAbort = function (response) {
                                        reject(new Exceptions.Exceptions.CommunicationException(createGetRolesErrorMessage(url_1, { detail: "Aborted", errorCode: response.statusCode })));
                                    };
                                    request.onTimeout = function (_) {
                                        reject(new Exceptions.Exceptions.CommunicationException(createGetRolesErrorMessage(url_1, { detail: "Timeout" })));
                                    };
                                    request.setTimeout(ROLES_REQUEST_TIMEOUT);
                                    setDeviceInfoHeaders(request);
                                    request.send();
                                    return [3, 3];
                                case 2:
                                    ex_1 = _a.sent();
                                    reject(ex_1);
                                    return [3, 3];
                                case 3: return [2];
                            }
                        });
                    }); })];
            });
        });
    }
    exports.getRoles = getRoles;
    function createGetRolesErrorMessage(url, _a) {
        var detail = _a.detail, errorCode = _a.errorCode;
        var msgDetail = !!detail ? " (".concat(detail, ")") : "";
        var msgErrorCode = !!errorCode ? " Error Code: ".concat(errorCode) : "";
        return "Error getting user roles from ".concat(url).concat(msgDetail, ".").concat(msgErrorCode);
    }
});
//# sourceMappingURL=Communication.js.map;
